import { styled, Typography } from "@mui/material";
import PLIcon from "components/patternLib/PLIcon";
import React from "react";

export const StyledActionButton = styled("button")(({ disabled }) => {
  return {
    all: "unset",
    display: "flex",
    alignItems: "center",
    color: disabled ? "#888E94" : "#000",
    lineHeight: 0,
    cursor: disabled ? "not-allowed" : "pointer",
  };
});

export interface ActionButtonProps {
  disabled?: boolean;
  fontSize?: string | number;
  iconName: string;
  iconSize?: string;
  label: string;
  onClick: () => void;
  style?: React.CSSProperties | undefined;
}

const ActionButton: React.FC<ActionButtonProps> = ({
  iconName,
  onClick,
  style,
  disabled,
  label,
  iconSize,
  fontSize,
}) => {
  return (
    <StyledActionButton onClick={onClick} style={style} disabled={disabled}>
      <PLIcon iconName={iconName} size={iconSize ?? "1.25rem"} />
      <Typography
        sx={{ fontFamily: "var(--copytext-font-family)", fontSize: fontSize ?? "15px", textTransform: "none" }}
      >
        {label}
      </Typography>
    </StyledActionButton>
  );
};

export default ActionButton;
